/*
 * @Author: cc
 * @Date: 2020-04-02 13:23:33
 * @LastEditTime: 2020-04-24 10:24:50
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\resourceCenter\stock\left\left.js
 * @Description: 
 */
/**
 * 描述：集团成品稿库左侧导航
 * 日期：2017-8-22
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('resourceCenterStockLeftModule', [])
    .directive('stockLeft', ['$state', 'resourceCenterService', '$q', '$timeout', '$stateParams', 'trsHttpService', '$location', function($state, resourceCenterService, $q, $timeout, $stateParams, trsHttpService, $location) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                selectedParent: '='
            },
            templateUrl: './resourceCenter/stock/left/left_tpl.html',
            link: function($scope, $elem, $attrs) {
                initStatus();

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {};
                    $scope.data = {};
                    if ($state.params.media_id) {
                        $scope.status.selected = $state.params.media_id;
                    }
                    watchParent();
                }

                /**
                 * [selectLeve3 description] 选中三级节点
                 * @param  {[type]} event      [description] 点击事件
                 * @param  {[type]} obj        [description] 所点选项
                 * @param  {[type]} parentItem [description] 父选项
                 * @return {[type]}            [description]
                 */
                $scope.selectLeve3 = function(item) {
                    resourceCenterService.go('front.resourcectrl.stock.resource', {
                        fcode: item.fcode,
                        media_id: item.media_id,
                        change: Math.random(0, 1) * 100,
                        name: item.name,
                    });
                    $scope.status.selected = item.media_id;
                };

                /**
                 * [watchParent description] 监控父节点变化
                 * @return {[type]} [description]
                 */
                function watchParent() {
                    $scope.$watch('selectedParent', (newV, oldV) => {
                        if (newV.fcode === oldV.fcode) {return;}
                        $scope.status.selected = '';
                    });
                }
            }
        };
    }]);
